import { createContext } from 'react';
import type { DocumentSaveType } from './types';

const DocumentSaveSteps = createContext<DocumentSaveType>(
  {} as DocumentSaveType,
);

export default DocumentSaveSteps;
